import gql from 'graphql-tag';

import {
  AlbumFolderBaseDetails,
  AlbumFolderChildrenCount,
  AlbumFolderDetails,
  AlbumFolderForReviewDetails,
  AlbumFolderMainCoverPhoto,
  AlbumFolderPendingCustomPrintDetails,
} from '../../../../../../graphql/fragments/album-folder';
import {
  AlbumForReview,
  AlbumListingDetails,
  AlbumRootAlbumFolderBaseDetails,
  PhotoUrlTypeFields,
} from '../../../../../../graphql/fragments/album';
import { AlbumPhotoGroupBasicDetails } from '../../../../../../graphql/fragments/album-photo-group';

export const AlbumFolderRootContentDetails = gql`
  fragment AlbumFolderRootContentDetails on AlbumFolder {
    id
    name
    album_type
    album_subtype
    join_code
    is_demo
    picture_day_enabled
    individual_albums
    photo_sharing_mode
    album_photos {
      total
    }
    album_photos_count
    parent {
      id
    }
    creator: account {
      id
    }
    cover_photos(slice: { limit: 1 }) {
      records {
        id
        faces_box
        thumbnail_urls(ignore_watermark: true) {
          ...PhotoUrlTypeFields
        }
      }
    }
    has_children
    ...AlbumFolderPendingCustomPrintDetails
    ...AlbumFolderMainCoverPhoto
    ...AlbumFolderForReviewDetails
  }
  ${AlbumFolderPendingCustomPrintDetails}
  ${AlbumFolderMainCoverPhoto}
  ${AlbumFolderForReviewDetails}
  ${PhotoUrlTypeFields}
`;

export const consumerRootContent = gql`
  query consumerRootContent(
    $limit: Int = 100
    $offset: Int = 0
    $owner_status: OwnerStatusFilterEnum = ALL
    $sort: HierarchyGroupsSort
    $search_query: String
    $include_matched_photos_only: Boolean = false
  ) {
    me {
      id
      hierarchy_groups(
        slice: { limit: $limit, offset: $offset }
        include_matched_photos_only: $include_matched_photos_only
        owner_status: $owner_status
        sort: $sort
        search_query: $search_query
        hierarchy_include_individual_albums: true
      ) {
        total
        records {
          id
          album_membership_group {
            id
            display_name
            is_album
            album {
              id
              album_type
              album_subtype
              purchased_event_addon_types
              creator {
                id
              }
              ...AlbumRootAlbumFolderBaseDetails
              account_hierarchy_settings {
                id
                notifications_enabled
              }
              ...AlbumForReview
            }
            album_folder {
              id
              album_type
              album_subtype
              start_date
              account {
                id
              }
              upload_mode
              root {
                id
                upload_mode
              }
              has_album
              account_hierarchy_settings {
                id
                notifications_enabled
              }
              album_photos_count
              has_album_photos
              purchased_event_addon_types
              ...AlbumFolderForReviewDetails
            }
            all_photos {
              total
            }
            matched_photos_extended {
              total
            }
            cover_photos(slice: { limit: 1 }) {
              records {
                id
                faces_box
                thumbnail_urls {
                  ...PhotoUrlTypeFields
                }
              }
            }
            album_memberships_has_all_photos_access
          }
          contributor_hierarchy_items {
            records {
              __typename
              ... on IContributorHierarchyItem {
                id
                parent_id
                item_type
                contributor_assignment {
                  id
                  upload_access
                  view_access
                  dnp_access
                }
              }

              ... on ContributorHierarchyAlbumFolderItem {
                album_folder {
                  id
                  name
                  creator: account {
                    id
                    name
                  }
                  album_type
                  album_subtype
                  cover_photos {
                    records {
                      id
                      faces_box
                      thumbnail_urls(ignore_watermark: true) {
                        ...PhotoUrlTypeFields
                      }
                    }
                  }

                  upload_mode
                  root {
                    id
                    upload_mode
                  }

                  account_hierarchy_settings {
                    id
                    notifications_enabled
                  }
                  ...AlbumFolderBaseDetails
                  ...AlbumFolderChildrenCount
                }
              }

              ... on ContributorHierarchyAlbumItem {
                album {
                  id
                  name
                  creator {
                    id
                    name
                  }
                  album_type
                  album_subtype
                  album_photo_groups(slice: { limit: 999 }) {
                    total
                    records {
                      ...AlbumPhotoGroupBasicDetails
                    }
                  }
                  account_hierarchy_settings {
                    id
                    notifications_enabled
                  }

                  ...AlbumRootAlbumFolderBaseDetails
                  ...AlbumListingDetails
                  ...AlbumForReview
                }
              }
            }
          }
          album_folder {
            id
            has_album
            upload_mode
            album_type
            album_subtype
            root {
              id
              upload_mode
            }
            account_hierarchy_settings {
              id
              notifications_enabled
            }
            ...AlbumFolderRootContentDetails
          }
        }
      }
    }
  }
  ${AlbumFolderRootContentDetails}
  ${AlbumFolderForReviewDetails}
  ${PhotoUrlTypeFields}
  ${AlbumFolderBaseDetails}
  ${AlbumFolderChildrenCount}
  ${AlbumPhotoGroupBasicDetails}
  ${AlbumListingDetails}
  ${AlbumForReview}
  ${AlbumRootAlbumFolderBaseDetails}
`;

export const albumFolderContents = gql`
  query albumFolderContents($id: RecordID!) {
    albumFolder(id: $id) {
      id
      ...AlbumFolderDetails
    }
  }
  ${AlbumFolderDetails}
`;
